import impressionClickCost from './impression_click_cost';
import goodEffect from './good_effect';
import accountStatistics from './account_statistics';
import { defaultDisplayColumnsConfig } from './default';

const allFieldsList = [...impressionClickCost, ...goodEffect, ...accountStatistics];

// 指标字段
export const targetFieldsList = allFieldsList.filter(field => field.type === 'target');

// 默认展示字段
export const defaultFieldsList = allFieldsList.filter(field => defaultDisplayColumnsConfig.includes(field.key));

export default allFieldsList;
